import * as React from 'react'
import { minutesToTime } from '../helpers/time'

type TableJobCollapsedRowsButtonProps = {
  hiddenLines: any[]
  toggleCollapse: () => void
}

export function TableJobCollapsedRowsButton(props: TableJobCollapsedRowsButtonProps) {
  const { hiddenLines, toggleCollapse } = props

  // Calculate total hours from all hidden lines
  const totalManHours = hiddenLines.reduce((sum, line) => {
    return sum + parseFloat(Number(line.staffing).toFixed(2))
  }, 0)
  const totalMachineHours = hiddenLines.reduce((sum, line) => {
    return sum + parseFloat(Number(line.machine_time).toFixed(2))
  }, 0)

  const manTime = minutesToTime(totalManHours)
  const machineTime = minutesToTime(totalMachineHours)

  return (
    <button className="btn btn-link production-planning-collapse-link" onClick={toggleCollapse}>
      {`Vis ${hiddenLines.length} flere - `}<span className="effection-icon effection-icon-printer ml-1"></span> {machineTime} /
      <span className="effection-icon effection-icon-user ml-1"></span> {manTime}
    </button>
  )
}
